/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { IOSScreenModeProto } from './iosscreen-mode-proto';
import { RectFStruct } from './rect-fstruct';

export class IOSScreenProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IOSScreenProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIOSScreenProto(bb: flatbuffers.ByteBuffer, obj?: IOSScreenProto): IOSScreenProto {
    return (obj || new IOSScreenProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIOSScreenProto(
    bb: flatbuffers.ByteBuffer,
    obj?: IOSScreenProto,
  ): IOSScreenProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IOSScreenProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('0');
  }

  bounds(obj?: RectFStruct): RectFStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? (obj || new RectFStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  nativeBounds(obj?: RectFStruct): RectFStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? (obj || new RectFStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  nativeScale(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
  }

  scale(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
  }

  currentMode(obj?: IOSScreenModeProto): IOSScreenModeProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new IOSScreenModeProto()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  preferredMode(obj?: IOSScreenModeProto): IOSScreenModeProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new IOSScreenModeProto()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  availableModes(index: number, obj?: IOSScreenModeProto): IOSScreenModeProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new IOSScreenModeProto()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  availableModesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  mirrored(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('0');
  }

  static startIOSScreenProto(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addId(builder: flatbuffers.Builder, id: bigint) {
    builder.addFieldInt64(0, id, BigInt('0'));
  }

  static addBounds(builder: flatbuffers.Builder, boundsOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, boundsOffset, 0);
  }

  static addNativeBounds(builder: flatbuffers.Builder, nativeBoundsOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, nativeBoundsOffset, 0);
  }

  static addNativeScale(builder: flatbuffers.Builder, nativeScale: number) {
    builder.addFieldFloat32(3, nativeScale, 0.0);
  }

  static addScale(builder: flatbuffers.Builder, scale: number) {
    builder.addFieldFloat32(4, scale, 0.0);
  }

  static addCurrentMode(builder: flatbuffers.Builder, currentModeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, currentModeOffset, 0);
  }

  static addPreferredMode(builder: flatbuffers.Builder, preferredModeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, preferredModeOffset, 0);
  }

  static addAvailableModes(builder: flatbuffers.Builder, availableModesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, availableModesOffset, 0);
  }

  static createAvailableModesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startAvailableModesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMirrored(builder: flatbuffers.Builder, mirrored: bigint) {
    builder.addFieldInt64(8, mirrored, BigInt('0'));
  }

  static endIOSScreenProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
